/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * bdk/v2/services/library.proto
 * OpenAPI spec version: version not set
 */

export type Bdkv2OAuthProvider =
  (typeof Bdkv2OAuthProvider)[keyof typeof Bdkv2OAuthProvider];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Bdkv2OAuthProvider = {
  OAuthProviderMicrosoft: 'OAuthProviderMicrosoft',
  OAuthProviderGoogle: 'OAuthProviderGoogle',
  OAuthProviderGeneric: 'OAuthProviderGeneric',
} as const;
